import React, {Fragment} from "react";
import landmark from "../../assets/imgs/landmark.svg";
import formatter from "../../helpers/number_formatter";
import {getUserType} from "../../helpers/authenticator";
import general_helper, {dateFormatter} from "../../helpers/general_helper";

const DeliveryItem = ({delivery}) => {
    let cardState = delivery.index === 0 ? "active-card" : "inactive-card";

    const callToAction = () => {
        switch (getUserType()) {
            case "rider":
                return (<a className="text-left small-text-blue" href={"/requests/" + delivery.item.delivery_id}>
                    View >>
                </a>);
            case "user":
                return (
                    <a className="text-left small-text-blue" href={"/deliveries/" + delivery.item.delivery_id}>
                        Track >>
                    </a>
                );
            default:
                return null
        }
    };

    let origin = delivery.item.pick_up.latitude + "," + delivery.item.pick_up.longitude;
    let destination = delivery.item.drop_off.latitude + "," + delivery.item.drop_off.longitude;


    return (
        <Fragment>
            <div className={"delivery-item-wrapper " + cardState}>
                <ul className="list-unstyled">
                    <li>
                        <div className="row">
                            <div className="col-6 text-left">
                                <p className="small-text-grey">{dateFormatter(delivery.item.created_at)}</p>
                            </div>
                            <div className="col-6 text-right">
                                <span
                                    className="badge badge-pill badge-primary">{general_helper.displayCurrentDeliveryStatus(delivery.item.status)}</span>
                                <h6>
                                    GH{formatter.accounting.formatMoney(delivery.item.quote.fee, "¢ ")}
                                </h6>
                            </div>
                        </div>
                    </li>
                    {delivery.index === 0 ? <li>
                        <img src={general_helper.generateGoogleStaticMap(origin, destination)} style={{marginTop: 10}}
                             className="img-fluid"/>
                    </li> : null}

                    <li>
                        <div className="row justify-content-center no-gutters">
                            <div className="col-1 text-left">
                                <img src={landmark} className="img-fluid" style={{
                                    textAlign: "right",
                                    height: 34, marginTop: 21, marginRight: 0
                                }}/>
                            </div>
                            <div className="col-11 text-left">
                                <ul className="list-unstyled delivery-locations-wrapper">
                                    <li><p style={{margin: 0, padding: 0, fontSize: 11}}>
                                        {delivery.item.pick_up.address}
                                    </p></li>
                                    <li><p style={{margin: 0, padding: 0, fontSize: 11}}>
                                        {delivery.item.drop_off.address}
                                    </p></li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    <li>
                        {delivery.showCTA ? callToAction() : null}
                    </li>
                </ul>
            </div>
        </Fragment>
    );
};


export default DeliveryItem;

